import { IModelEntity, IBaseService } from '@pit/core';
import { IEntityStoreFacade } from './entity.store.facae.interface';

export interface IEntityFacadesAccessorService extends IBaseService {

    getEntityFacade<T extends IModelEntity>(serviceName: string): IEntityStoreFacade<T>;
    registerEntityFacade<T extends IModelEntity>(serviceName: string, entityFacade: IEntityStoreFacade<T>): void;

}
